import { StyledTranslationsOnImage } from './TranslationsOnImage.styled';
import useTranslationsOnImage from './useTranslationsOnImage.hook';
import Explanation from './Explanation/Explanation';
import { Tooltip } from 'antd';
import { useRef } from 'react';

export default function TranslationsOnImage({
  imgRef,
  translations,
  editing = false,
  className = '',
}) {
  const containerRef = useRef(null);
  const { state } = useTranslationsOnImage({
    imgRef,
  });

  if (!imgRef.current || !translations?.length) {
    return null;
  }

  return (
    <StyledTranslationsOnImage
      style={{
        width: `${state.imgWidth}px`,
        height: `${state.imgHeight}px`,
      }}
      ref={containerRef}
      className={className}
    >
      {translations?.map((translation) => {
        const { Width, Height, Left, Top } = translation.Geometry.BoundingBox;
        return (
          <Tooltip
            key={translation.Id}
            trigger="click"
            title={<Explanation translation={translation} />}
            getPopupContainer={() => containerRef.current}
            overlayClassName="translation-tooltip"
          >
            <span
              key={translation.Id}
              className={`translation-button ${editing ? 'editing' : ''}`}
              style={{
                width: `${Width * 100}%`,
                height: `${Height * 100}%`,
                left: `${Left * 100}%`,
                top: `${Top * 100}%`,
              }}
            ></span>
          </Tooltip>
        );
      })}
    </StyledTranslationsOnImage>
  );
}
